import { el, setAttr } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

class EventRegistration {

  constructor() {

    this.authenticated = application.isAuthenticated();
    this.currentUser = application.getUser();

    this.guestProfileImageContainerViewEl = el('div.guest-profile-image-view-container');
    this.guestNameViewEl = el('label.guest-name', '');
    this.guestProfileContainerViewEl = el('div.guest-profile-container', [this.guestProfileImageContainerViewEl, this.guestNameViewEl]);
    this.userTypeLabelEl = el('div');
    this.guestProfileControlViewEl = el('div.guest-control-container', this.userTypeLabelEl);

    this.el = el('div.event-guest-view', [this.guestProfileContainerViewEl, this.guestProfileControlViewEl]);

  }

  displayToastMessage(message, type) {

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: message,
      seconds: 5,
      type
    });

  }

  async handleRemoveGuestControlClick(userId) {

    const result = await serverInterface.startup.community.events.deleteEventRegistrationByIdAndUserId(this.postId, userId);

    if (result === true) {
      this.handleRemoveGuest({ userId });
      this.displayToastMessage('Successfully removed guest', 'info');
      return;
    }

    this.displayToastMessage('Unable to remove. Contact administrator!', 'error');
    return;

  }

  getUserTypeClassAndLabel(eventOwnerId, registration) {

    if (this.authenticated === false) {
      return {
        class: '',
        label: ''
      };
    }

    if (registration._id === eventOwnerId) {
      return {
        class: 'host-label',
        label: 'Host'
      };
    }

    return {
      class: 'guest-label',
      label: 'Guest'
    };

  }

  update(registration, index, registrations, eventOwnerId) {

    this.guestNameViewEl.textContent = registration.fullName;

    setAttr(this.guestProfileImageContainerViewEl, {
      style: {
        backgroundImage: `url(${registration.profilePicture.url})`
      }
    });

    const classAndLabel = this.getUserTypeClassAndLabel(eventOwnerId, registration);

    setAttr(this.userTypeLabelEl, {
      class: classAndLabel.class
    });

    this.userTypeLabelEl.textContent = classAndLabel.label;

  }

}

export default EventRegistration;